import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";
import Pagination from "../../Components/Pagination/Pagination";
import { toast } from "react-toastify";
import closeIcon from "../../assets/icons/close.svg";
import { IoEye } from "react-icons/io5";
import { IoCheckmark } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import Loader from "../../Components/LoaderAndSpinner/Loader";

import "../../assets/css/addunit.css";

const AssetTagMapping = () => {
  const [usecases, setUsecases] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUsecase, setSelectedUsecase] = useState(null);
  const [selectedCdhTagId, setSelectedCdhTagId] = useState(null);
  const [usecaseMatchResults, setUsecaseMatchResults] = useState({});
  const [cdhTagIds, setCdhTagIds] = useState([]);
  const [spvMappings, setSpvMappings] = useState({});
  const [usecaseSPVs, setUsecaseSPVs] = useState({});
  const [spvMatchResults, setSpvMatchResults] = useState({});
  const [showSpvModal, setShowSpvModal] = useState(false);
  const [selectedUsecaseSpvs, setSelectedUsecaseSpvs] = useState([]);
  const [selectedUsecaseName, setSelectedUsecaseName] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const navigate = useNavigate();

  // -------------------------------------------------------
  const [masterOptionsMap, setMasterOptionsMap] = useState({});
  const [errorrowMessages, setErrorrowMessages] = useState([]);
  const [editRowTemplateId, setEditRowTemplateId] = useState(null);
  const [assets, setAssets] = useState([]);
  const [assetId, setAssetId] = useState("");
  const [assetAttributes, setAssetAttributes] = useState([]);
  const [assetTemplates, setAssetTemplates] = useState([]);

  const [editRowIndex, setEditRowIndex] = useState(null);
  const [editRowValues, setEditRowValues] = useState({});

  const [templateMasters, setTemplateMasters] = useState({});
  const [assetMasters, setAssetMasters] = useState([]);

  const [formValues, setFormValues] = useState({});
  const [selectedValues, setSelectedValues] = useState({});
  const [rows, setRows] = useState({});

  const [errforsubmit, seterrforsubmit] = useState("");
  const [errors, setErrors] = useState({});


  const { equipment_id } = useParams();
  const [errorMessages, setErrorMessages] = useState([]);

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [selectedTemplateName, setSelectedTemplateName] = useState(null);
  
  // Ref for CDH Tag input field to set focus
  const cdhTagInputRef = useRef(null);




  // Load assets only when needed (not on page load)
  const getAssetClass = async () => {
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset/getall`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({}),
              },
              navigate
          );

          setAssets(data || []);
      } catch (error) {
          if (error.message === "Unauthorized") {
              navigate("/auth/login");
          }
      }
  };

  // Function to fetch SPVs for all usecases
  // Function to find equipment by CDH Tag ID and extract SPVs
  const findEquipmentByCDHTag = async (cdhTagId) => {
    try {
      console.log("🔍 Finding equipment for CDH Tag ID:", cdhTagId);
      
      
      // Fetch all equipment
      const equipmentResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/getall`,
        { method: "POST", body: JSON.stringify({}) }
      );
      
      const allEquipment = equipmentResponse.data || equipmentResponse;
      console.log("📊 Total equipment found:", allEquipment.length);
      
      // Find equipment containing the CDH Tag ID
      const normalizedCdhTagId = cdhTagId.trim();
      const matchingEquipment = allEquipment.find(equipment => {
        if (!equipment.templates) return false;
        
        // Check all template arrays in the equipment
        for (const templateId in equipment.templates) {
          const templateArray = equipment.templates[templateId];
          if (Array.isArray(templateArray)) {
            for (const templateItem of templateArray) {
              if (templateItem && typeof templateItem === 'object') {
                // Check all properties of the template item
                for (const prop in templateItem) {
                  if (templateItem[prop] && typeof templateItem[prop] === 'object') {
                    // Check if it has a value property - normalize comparison
                    const propValue = String(templateItem[prop].value || '').trim();
                    if (propValue === normalizedCdhTagId) {
                      console.log(`✅ Found CDH Tag ID match in equipment: ${equipment.equipment_name}`);
                      return true;
                    }
                  } else {
                    // Also check direct value match
                    const directValue = String(templateItem[prop] || '').trim();
                    if (directValue === normalizedCdhTagId) {
                      console.log(`✅ Found CDH Tag ID match (direct) in equipment: ${equipment.equipment_name}`);
                      return true;
                    }
                  }
                }
              }
            }
          }
        }
        return false;
      });
      
      if (matchingEquipment) {
        console.log("✅ Found matching equipment:", matchingEquipment);
        return matchingEquipment;
      } else {
        console.log("❌ No equipment found with CDH Tag ID:", cdhTagId);
        return null;
      }
    } catch (error) {
      console.error("❌ Error finding equipment:", error);
      return null;
    }
  };

  // Function to extract SPVs from equipment templates
  const extractSPVsFromEquipment = (equipment, cdhTagId) => {
    try {
      console.log("🔍 Extracting SPVs from equipment:", equipment.equipment_name);
      console.log("🔍 Looking for CDH Tag ID:", cdhTagId);
      console.log("🔍 Equipment templates:", equipment.templates);
      
      const spvs = [];
      
      if (!equipment.templates) {
        console.log("❌ No templates found in equipment");
        return spvs;
      }
      
      // Iterate through all template arrays
      for (const templateId in equipment.templates) {
        const templateArray = equipment.templates[templateId];
        console.log(`🔍 Processing template ${templateId}:`, templateArray);
        
        if (Array.isArray(templateArray)) {
          for (const templateItem of templateArray) {
            console.log("🔍 Processing template item:", templateItem);
            
            if (templateItem && typeof templateItem === 'object') {
              console.log("🔍 Checking template item for CDH Tag ID:", cdhTagId);
              console.log("🔍 Template item structure:", templateItem);
              
              // First, check if this template item contains the CDH Tag ID
              let containsCdhTag = false;
              let matchingProperty = null;
              const normalizedCdhTagId = cdhTagId.trim();
              
              for (const prop in templateItem) {
                console.log(`🔍 Checking property ${prop}:`, templateItem[prop]);
                
                if (templateItem[prop] && typeof templateItem[prop] === 'object') {
                  const propValue = String(templateItem[prop].value || '').trim();
                  console.log(`🔍 Property ${prop} value: "${propValue}"`);
                  console.log(`🔍 Comparing "${propValue}" with "${normalizedCdhTagId}"`);
                  
                  if (propValue === normalizedCdhTagId) {
                    containsCdhTag = true;
                    matchingProperty = prop;
                    console.log(`✅ Found CDH Tag ID match in property ${prop}!`);
                    break;
                  }
                } else {
                  // Also check direct value
                  const directValue = String(templateItem[prop] || '').trim();
                  if (directValue === normalizedCdhTagId) {
                    containsCdhTag = true;
                    matchingProperty = prop;
                    console.log(`✅ Found CDH Tag ID match (direct) in property ${prop}!`);
                    break;
                  }
                }
              }
              
              // Only process this template item if it contains the CDH Tag ID
              if (containsCdhTag) {
                console.log(`🎯 Processing template item that contains CDH Tag ID in property ${matchingProperty}`);
                console.log("🎯 Full template item:", templateItem);
                
                // Look for SPV-related properties in this specific object
                for (const prop in templateItem) {
                  console.log(`🔍 Processing property ${prop}:`, templateItem[prop]);
                  
                  if (templateItem[prop] && typeof templateItem[prop] === 'object') {
                    // Check if this looks like an SPV (has text property with meaningful content)
                    if (templateItem[prop].text && templateItem[prop].text.trim()) {
                      const spvText = templateItem[prop].text.trim();
                      console.log(`🔍 Found text: "${spvText}"`);
                      
                      // More lenient filtering - exclude only unit values, include everything else with meaningful length
                      const excludedValues = ['degC', 'TPH', 'kW', 'bar', 'psi', 'rpm', '%', 'm', 'cm', 'mm'];
                      const isExcluded = excludedValues.some(excluded => spvText.toLowerCase() === excluded.toLowerCase());
                      
                      if (!isExcluded && spvText.length > 2 && spvText !== '') {
                        console.log(`✅ Adding SPV: "${spvText}"`);
                        spvs.push(spvText);
                      } else {
                        console.log(`❌ Filtered out: "${spvText}" (excluded or too short)`);
                      }
                    }
                  }
                }
              } else {
                console.log("⏭️ Skipping template item - no CDH Tag ID match");
              }
            }
          }
        }
      }
      
      // Remove duplicates
      const uniqueSPVs = [...new Set(spvs)];
      console.log("📋 Final extracted SPVs:", uniqueSPVs);
      
      return uniqueSPVs;
    } catch (error) {
      console.error("❌ Error extracting SPVs from equipment:", error);
      return [];
    }
  };

  // Function to match equipment SPVs with usecase SPVs
  const matchSPVsWithUsecases = (equipmentSPVs, usecaseSPVs) => {
    try {
      console.log("🔍 Matching equipment SPVs with usecase SPVs");
      console.log("Equipment SPVs:", equipmentSPVs);
      console.log("Usecase SPVs:", usecaseSPVs);
      
      const matchResults = {};
      
      // Iterate through each usecase
      for (const usecaseName in usecaseSPVs) {
        const usecaseSPVList = usecaseSPVs[usecaseName];
        console.log(`🔍 Checking usecase: ${usecaseName}`);
        console.log(`Usecase SPVs:`, usecaseSPVList);
        
        const matches = [];
        
        // Check each equipment SPV against usecase SPVs
        for (const equipmentSPV of equipmentSPVs) {
          console.log(`🔍 Checking equipment SPV: "${equipmentSPV}"`);
          
          for (const usecaseSPV of usecaseSPVList) {
            // Extract the actual SPV value (could be document_code or mapped_value)
            const usecaseSPVValue = usecaseSPV.document_code || usecaseSPV.mapped_value || '';
            console.log(`🔍 Comparing with usecase SPV: "${usecaseSPVValue}"`);
            
            // More flexible matching - check for keyword matches
            const equipmentKeywords = equipmentSPV.toLowerCase().split(/[\s,-]+/).filter(k => k.length > 2);
            const usecaseKeywords = usecaseSPVValue.toLowerCase().split(/[\s,-]+/).filter(k => k.length > 2);
            
            console.log(`🔍 Equipment keywords:`, equipmentKeywords);
            console.log(`🔍 Usecase keywords:`, usecaseKeywords);
            
            // Check for exact match
            if (equipmentSPV.toLowerCase() === usecaseSPVValue.toLowerCase()) {
              console.log(`✅ Exact match found: "${equipmentSPV}" === "${usecaseSPVValue}"`);
              matches.push({
                equipmentSPV: equipmentSPV,
                usecaseSPV: usecaseSPVValue,
                matchType: 'exact'
              });
            }
            // Check for partial matches (equipment SPV contains usecase SPV or vice versa)
            else if (equipmentSPV.toLowerCase().includes(usecaseSPVValue.toLowerCase()) ||
                     usecaseSPVValue.toLowerCase().includes(equipmentSPV.toLowerCase())) {
              console.log(`✅ Partial match found: "${equipmentSPV}" contains "${usecaseSPVValue}" or vice versa`);
              matches.push({
                equipmentSPV: equipmentSPV,
                usecaseSPV: usecaseSPVValue,
                matchType: 'partial'
              });
            }
            // Check for keyword overlap
            else {
              const commonKeywords = equipmentKeywords.filter(k => usecaseKeywords.includes(k));
              if (commonKeywords.length > 0) {
                console.log(`✅ Keyword match found:`, commonKeywords);
                matches.push({
                  equipmentSPV: equipmentSPV,
                  usecaseSPV: usecaseSPVValue,
                  matchType: 'keyword',
                  commonKeywords: commonKeywords
                });
              }
            }
          }
        }
        
        matchResults[usecaseName] = {
          hasMatch: matches.length > 0,
          matches: matches,
          matchedSPVs: matches.map(m => m.equipmentSPV)
        };
        
        console.log(`📊 Results for ${usecaseName}:`, matchResults[usecaseName]);
      }
      
      return matchResults;
    } catch (error) {
      console.error("❌ Error matching SPVs:", error);
      return {};
    }
  };

  // Helper: get all tag texts from an equipment
  const getEquipmentTagTexts = (equipment) => {
    const tagTexts = [];
    if (equipment && equipment.templates && typeof equipment.templates === 'object') {
      Object.values(equipment.templates).forEach((templateArray) => {
        if (Array.isArray(templateArray)) {
          templateArray.forEach((attributeObj) => {
            if (attributeObj && typeof attributeObj === 'object') {
              Object.values(attributeObj).forEach((tag) => {
                if (tag && typeof tag === 'object' && tag.text) {
                  tagTexts.push(String(tag.text));
                } else if (typeof tag === 'string') {
                  tagTexts.push(tag);
                }
              });
            }
          });
        }
      });
    }
    return tagTexts;
  };

  // Helper: remove two leading prefixes (e.g., FILES-CSV-*) from a document code
  const getBaseNameFromDocumentCode = (documentCode) => {
    if (!documentCode || typeof documentCode !== 'string') return '';
    let baseName = documentCode;
    if (baseName.includes('-')) {
      baseName = baseName.substring(baseName.indexOf('-') + 1);
    }
    if (baseName.includes('-')) {
      baseName = baseName.substring(baseName.indexOf('-') + 1);
    }
    return baseName;
  };

  const fetchUsecaseSPVs = async (usecases) => {
    try {
      console.log("🔍 Fetching SPVs for all usecases...");
      
      // Step 1: Get master ID for "Standard Process Variables"
      const spvMasterResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/get-standard-process-variables-master`,
        { method: "POST", body: JSON.stringify({}) }
      );
      
      const spvMaster = spvMasterResponse.data || spvMasterResponse;
      console.log("📊 SPV Master found:", spvMaster);
      
      if (!spvMaster || !spvMaster._id) {
        console.log("❌ No SPV Master found");
        return {};
      }
      
      const masterId = spvMaster._id;
      console.log("📊 SPV Master ID:", masterId);
      
      // Step 2: Get template masters for each usecase template
      const templateMasters = [];
      
      for (const usecase of usecases) {
        const templateId = usecase._id;
        console.log(`🔍 Fetching template masters for template: ${templateId}`);
        
        try {
          const templateMastersResponse = await fetchWrapper(
            `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-masters/${templateId}`,
            { method: "POST", body: JSON.stringify({}) }
          );
          
          const templateMastersForTemplate = templateMastersResponse.data || [];
          console.log(`📊 Template masters for template ${templateId}:`, templateMastersForTemplate.length);
          
          // Filter by master ID
          const filteredMasters = templateMastersForTemplate.filter(tm => tm.master_id === masterId);
          templateMasters.push(...filteredMasters);
          console.log(`📊 Filtered template masters for template ${templateId}:`, filteredMasters.length);
        } catch (error) {
          console.log(`❌ Error fetching template masters for template ${templateId}:`, error);
        }
      }
      
      console.log("📊 Total template masters found:", templateMasters.length);
      
      // Step 3: Group template masters by template_id
      const templateMastersByTemplateId = {};
      templateMasters.forEach(tm => {
        if (!templateMastersByTemplateId[tm.template_id]) {
          templateMastersByTemplateId[tm.template_id] = [];
        }
        templateMastersByTemplateId[tm.template_id].push(tm);
      });
      
      console.log("📊 Template Masters grouped by template_id:", Object.keys(templateMastersByTemplateId));
      
      // Step 4: Extract SPVs for each usecase
      const usecaseSPVs = {};
      
      usecases.forEach(usecase => {
        const usecaseName = usecase.template_name || usecase;
        const templateId = usecase._id;
        
        console.log(`🔍 Processing usecase: ${usecaseName} (template_id: ${templateId})`);
        
        if (templateMastersByTemplateId[templateId]) {
          const spvs = templateMastersByTemplateId[templateId].map(tm => ({
            document_code: tm.document_code,
            mapped_value: tm.mapped_value,
            master_name: tm.master_name
          }));
          
          usecaseSPVs[usecaseName] = spvs;
          console.log(`📋 SPVs for usecase "${usecaseName}":`, spvs);
        } else {
          usecaseSPVs[usecaseName] = [];
          console.log(`❌ No SPVs found for usecase "${usecaseName}"`);
        }
      });
      
      console.log("📋 All usecase SPVs:", usecaseSPVs);
      setUsecaseSPVs(usecaseSPVs);
      return usecaseSPVs;
      
    } catch (error) {
      console.error("❌ Error fetching usecase SPVs:", error);
      return {};
    }
  };

  useEffect(() => {
    const getUsecases = async () => {
      try {
        const data = await fetchWrapper(
          `${process.env.REACT_APP_BASE_API_URL1}/api/v1/get-usecase`,
          { method: "POST", body: JSON.stringify({}) }
        );

        const usecase_id = data._id;
        const result = await fetchWrapper(
          `${process.env.REACT_APP_BASE_API_URL1}/api/v1/templates/type/${usecase_id}`,
          { method: "POST", body: JSON.stringify({}) }
        );
        const usecases = result.templates || [];
        setUsecases(usecases);
        
        // Don't fetch SPVs on page load - will fetch on submit instead
      } catch (error) {
        if (error.message === "Unauthorized") navigate("/auth/login");
      }
    };
    getUsecases();
  }, [navigate]);

  const getEquipment = async (equipmentId) => {
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/view/${equipmentId}`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({}),
              },
              navigate
          );

          // setEquipment(data.data || {});
          setFormValues(data.data || {}); // Set form values with the fetched data
          setRows(data.data.templates || []); // Set rows with the fetched data
          setAssetId(data.data.asset_id); // Set the assetId state
          handleAssetClassChange(data.data.asset_id);
      } catch (error) {
          if (error.message === "Unauthorized") {
              navigate("/auth/login");
          }
      }
  };
  const handleEditInputChange1 = (id, selectedOption, isDropdown = false) => {
      setEditRowValues((prevValues) => {
          const updatedValue = {
              value: isDropdown
                  ? selectedOption?.label || "" // ✅ store label, not value/id
                  : selectedOption
          };

          return {
              ...prevValues,
              [id]: updatedValue,
          };
      });
  };
  const handleAssetClassChange = async (asset_id) => {
      setAssetId(asset_id);
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-class-attribute/${asset_id}`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({}),
              },
              navigate
          );

          setAssetAttributes(data.asset_attributes || []);

          try {
              await getAssetTemplates(asset_id);
          } catch (error) {
              toast.error("Failed to fetch asset templates.");
          }

          try {
              await getAssetMasters(asset_id);
          } catch (error) {
              toast.error("Failed to fetch asset masters.");
          }
      } catch (error) {
          toast.error("An error occurred while fetching data.");
          if (error.message === "Unauthorized") {
              navigate("/auth/login");
          }
      }
  };

  const getAssetTemplates = async (asset_id) => {
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-templates/${asset_id}/attributes`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({}),
              },
              navigate
          );
          setAssetTemplates(data || []);

          // Fetch template masters for each template
          const templateMastersPromises = data.map((template) =>
              getTemplateMasters(template, asset_id)
          );

          // Wait for all template masters promises to resolve
          const templateMastersData = await Promise.all(templateMastersPromises);

          // Create a map of template masters
          const templateMastersMap = data.reduce((acc, template, index) => {
              acc[template._id] = templateMastersData[index];
              return acc;
          }, {});

          // Set template masters state
          setTemplateMasters(templateMastersMap);
      } catch (error) {
          if (error.message === "Unauthorized") {
              navigate("/auth/login");
          }
      }
  };

  const getTemplateMasters = async (template, asset_id) => {
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-masters/${template._id}/leaf-group`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                      asset_id,
                  }),
              },
              navigate // Include navigate if needed for error handling
          );

          return data.data || []; // Ensure data is an array, handle null case
      } catch (error) {
          if (error.message === "Unauthorized") {
              navigate("/auth/login"); // Navigate to login if unauthorized
          }
          return []; // Handle error gracefully, return empty array or default value
      }
  };
  const getAssetMasters = async (asset_id) => {
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-masters/${asset_id}`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({}),
              },
              navigate
          );

          setAssetMasters(data.data || []);
      } catch (error) {
          if (error.message === "Unauthorized") {
              navigate("/auth/login");
          }
      }
  };


  // Function to extract SPV for a selected CDH Tag ID
  const extractCDHTagSPV = async (cdhTagId) => {
    try {
      console.log("🔍 Extracting SPV for CDH Tag ID:", cdhTagId);
      
      // Get template attributes for CDH Tag
      const templateAttributesResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-attribute/getall`,
        { method: "POST", body: JSON.stringify({}) }
      );
      
      const allTemplateAttributes = Array.isArray(templateAttributesResponse) 
        ? templateAttributesResponse 
        : (templateAttributesResponse?.data || []);
      
      const cdhTagAttributes = allTemplateAttributes.filter(attr => 
        attr.field_name === "var_cdh_tag"
      );
      
      console.log("📊 CDH Tag attributes found:", cdhTagAttributes.length);
      
      if (cdhTagAttributes.length === 0) {
        console.log("❌ No CDH Tag attributes found");
        return [];
      }
      
      // Get template IDs from CDH Tag attributes
      const templateIds = cdhTagAttributes.map(attr => attr.template_id).filter(Boolean);
      console.log("📊 Template IDs to search:", templateIds);
      
      // Get all equipments
      const equipmentResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/getall`,
        { method: "POST", body: JSON.stringify({}) }
      );
      
      const equipments = equipmentResponse?.data || [];
      console.log("📊 Total equipments to search:", equipments.length);
      
      const cdhTagSPVs = new Set();
      
      // Search for the CDH Tag ID in equipment templates
      equipments.forEach((equipment, equipmentIndex) => {
        if (equipment.templates && typeof equipment.templates === "object") {
          templateIds.forEach(templateId => {
            const templateIdStr = templateId.toString();
            
            if (equipment.templates[templateIdStr]) {
              const templateArray = equipment.templates[templateIdStr];
              
              if (Array.isArray(templateArray)) {
                templateArray.forEach((templateItem, itemIndex) => {
                  if (templateItem && typeof templateItem === 'object') {
                    // Check if this template item contains the selected CDH Tag ID
                    let containsCdhTag = false;
                    const spvValues = [];
                    
                    Object.entries(templateItem).forEach(([key, value]) => {
                      if (typeof value === 'string' && value.includes(cdhTagId)) {
                        containsCdhTag = true;
                        console.log(`✅ Found CDH Tag ID "${cdhTagId}" in equipment ${equipmentIndex + 1}, template ${templateIdStr}, item ${itemIndex}, key "${key}"`);
                      }
                      
                      // Collect all string values as potential SPVs
                      if (typeof value === 'string' && value.trim() && !value.includes('V-')) {
                        spvValues.push(value.trim());
                      } else if (value && typeof value === 'object') {
                        Object.entries(value).forEach(([subKey, subValue]) => {
                          if (typeof subValue === 'string' && subValue.trim() && !subValue.includes('V-')) {
                            spvValues.push(subValue.trim());
                          }
                        });
                      }
                    });
                    
                    // If this template item contains the CDH Tag, add its SPVs
                    if (containsCdhTag) {
                      spvValues.forEach(spv => {
                        if (spv && spv.length > 0) {
                          cdhTagSPVs.add(spv);
                          console.log(`📋 Found SPV for CDH Tag "${cdhTagId}": ${spv}`);
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      });
      
      const spvArray = Array.from(cdhTagSPVs).sort();
      console.log("📋 Total SPVs found for CDH Tag ID:", cdhTagId, ":", spvArray.length);
      console.log("📋 SPVs for CDH Tag ID:", cdhTagId, ":", spvArray);
      
      return spvArray;
    } catch (error) {
      console.error("❌ Error extracting CDH Tag SPV:", error);
      return [];
    }
  };

  // Function to fetch equipment that contains the selected CDH Tag ID
  const fetchEquipmentForCDHTag = async (cdhTagId) => {
    try {
      console.log("🔍 Fetching equipment for CDH Tag ID:", cdhTagId);
      
      // Get template attributes for CDH Tag
      const templateAttributesResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-attribute/getall`,
        { method: "POST", body: JSON.stringify({}) }
      );
      
      const allTemplateAttributes = Array.isArray(templateAttributesResponse) 
        ? templateAttributesResponse 
        : (templateAttributesResponse?.data || []);
      
      const cdhTagAttributes = allTemplateAttributes.filter(attr => 
        attr.field_name === "var_cdh_tag"
      );
      
      if (cdhTagAttributes.length === 0) {
        console.log("❌ No CDH Tag attributes found");
        return [];
      }
      
      // Get template IDs from CDH Tag attributes
      const templateIds = cdhTagAttributes.map(attr => attr.template_id).filter(Boolean);
      console.log("📊 Template IDs to search:", templateIds);
      
      // Get all equipments
      const equipmentResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/getall`,
        { method: "POST", body: JSON.stringify({}) }
      );
      
      const equipments = equipmentResponse?.data || [];
      console.log("📊 Total equipments to search:", equipments.length);
      
      const matchingEquipments = [];
      
      // Search for the CDH Tag ID in equipment templates
      equipments.forEach((equipment, equipmentIndex) => {
        if (equipment.templates && typeof equipment.templates === "object") {
          templateIds.forEach(templateId => {
            const templateIdStr = templateId.toString();
            
            if (equipment.templates[templateIdStr]) {
              const templateArray = equipment.templates[templateIdStr];
              
              if (Array.isArray(templateArray)) {
                templateArray.forEach((templateItem, itemIndex) => {
                  if (templateItem && typeof templateItem === 'object') {
                    // Check if this template item contains the selected CDH Tag ID
                    let containsCdhTag = false;
                    
                    Object.entries(templateItem).forEach(([key, value]) => {
                      console.log(`Checking key: ${key}, value:`, value);
                      
                      if (typeof value === 'string' && value.includes(cdhTagId)) {
                        containsCdhTag = true;
                        console.log(`✅ Found CDH Tag ID "${cdhTagId}" in equipment ${equipmentIndex + 1}, template ${templateIdStr}, item ${itemIndex}, key "${key}" (string)`);
                      } else if (value && typeof value === 'object') {
                        // Check if the object has a 'value' property that contains the CDH Tag ID
                        if (value.value && typeof value.value === 'string' && value.value.includes(cdhTagId)) {
                          containsCdhTag = true;
                          console.log(`✅ Found CDH Tag ID "${cdhTagId}" in equipment ${equipmentIndex + 1}, template ${templateIdStr}, item ${itemIndex}, key "${key}" (object.value)`);
                        }
                        
                        // Also check other string properties
                        Object.entries(value).forEach(([subKey, subValue]) => {
                          if (typeof subValue === 'string' && subValue.includes(cdhTagId)) {
                            containsCdhTag = true;
                            console.log(`✅ Found CDH Tag ID "${cdhTagId}" in equipment ${equipmentIndex + 1}, template ${templateIdStr}, item ${itemIndex}, key "${key}.${subKey}" (object.${subKey})`);
                          }
                        });
                      }
                    });
                    
                    // If this template item contains the CDH Tag, add the equipment
                    if (containsCdhTag) {
                      const equipmentInfo = {
                        equipment_id: equipment._id,
                        equipment_code: equipment.equipment_code,
                        equipment_name: equipment.equipment_name,
                        size: equipment.size,
                        capacity: equipment.capacity,
                        oem: equipment.oem,
                        process_type: equipment.process_type,
                        asset_id: equipment.asset_id,
                        template_id: templateIdStr,
                        template_item_index: itemIndex,
                        template_item: templateItem,
                        created_at: equipment.created_at,
                        updated_at: equipment.updated_at
                      };
                      
                      matchingEquipments.push(equipmentInfo);
                      
                      // Enhanced console logging for equipment details
                      console.log(`📋 Equipment using CDH Tag "${cdhTagId}":`);
                      console.log(`   Equipment ID: ${equipment._id}`);
                      console.log(`   Equipment Code: ${equipment.equipment_code}`);
                      console.log(`   Equipment Name: ${equipment.equipment_name}`);
                      console.log(`   Size: ${equipment.size}`);
                      console.log(`   Capacity: ${equipment.capacity}`);
                      console.log(`   OEM: ${equipment.oem}`);
                      console.log(`   Process Type: ${equipment.process_type}`);
                      console.log(`   Asset ID: ${equipment.asset_id}`);
                      console.log(`   Template ID: ${templateIdStr}`);
                      console.log(`   Template Item Index: ${itemIndex}`);
                      console.log(`   Full Equipment Data:`, equipmentInfo);
                    }
                  }
                });
              }
            }
          });
        }
      });
      
      console.log("📋 Total equipments found for CDH Tag ID:", cdhTagId, ":", matchingEquipments.length);
      
      if (matchingEquipments.length > 0) {
        console.log("📋 Summary of equipments using CDH Tag ID:", cdhTagId);
        matchingEquipments.forEach((equipment, index) => {
          console.log(`   ${index + 1}. ${equipment.equipment_name} (${equipment.equipment_code}) - ID: ${equipment.equipment_id}`);
        });
        console.log("📋 Complete equipment data:", matchingEquipments);
      } else {
        console.log("❌ No equipments found using CDH Tag ID:", cdhTagId);
      }
      
      return matchingEquipments;
    } catch (error) {
      console.error("❌ Error fetching equipment for CDH Tag:", error);
      return [];
    }
  };

  // Function to handle CDH Tag ID change
  const handleCdhTagIdChange = async (cdhTagIds) => {
    if (!cdhTagIds) {
      setGroupedData([]);
      setSpvMatchResults({});
      return;
    }

    setLoading(true);
    setSelectedCdhTagId(cdhTagIds);
    
    try {
      console.log("🎯 Processing CDH Tag IDs:", cdhTagIds);
      console.log("🎯 Current usecases count:", usecases.length);
      console.log("🎯 Current usecases:", usecases);
      console.log("🎯 Current usecaseSPVs:", usecaseSPVs);
      
      // Split comma-separated CDH Tag IDs
      const cdhTagIdArray = cdhTagIds.split(',').map(id => id.trim()).filter(Boolean);
      console.log("🎯 Processing multiple CDH Tag IDs:", cdhTagIdArray);
      
      if (cdhTagIdArray.length === 0) {
        console.log("❌ No valid CDH Tag IDs provided");
        setSpvMatchResults({});
        return;
      }
      
      // Step 1: Fetch usecase SPVs if not already loaded
      let workingUsecaseSPVs = usecaseSPVs;
      if (Object.keys(workingUsecaseSPVs).length === 0 && usecases.length > 0) {
        console.log("🔄 Loading usecase SPVs...");
        workingUsecaseSPVs = await fetchUsecaseSPVs(usecases);
        console.log("✅ Usecase SPVs loaded:", Object.keys(workingUsecaseSPVs).length);
      }
      
      // Step 2: Find equipment for each CDH Tag ID and collect tag texts with CDH Tag mapping
      const cdhTagToEquipmentTags = {}; // Map CDH Tag ID to its equipment tags
      let foundEquipment = false;
      
      for (const cdhTagId of cdhTagIdArray) {
        console.log("🔍 Processing CDH Tag ID:", cdhTagId);
        const equipment = await findEquipmentByCDHTag(cdhTagId);
        
        if (equipment) {
          foundEquipment = true;
          console.log("✅ Found equipment for CDH Tag ID:", cdhTagId);
          const equipmentTagTexts = getEquipmentTagTexts(equipment);
          cdhTagToEquipmentTags[cdhTagId] = equipmentTagTexts;
        } else {
          console.log("❌ No equipment found with CDH Tag ID:", cdhTagId);
        }
      }
      
      if (!foundEquipment) {
        console.log("❌ No equipment found for any of the provided CDH Tag IDs");
        setSpvMatchResults({});
        return;
      }
      
      // Step 3: Match SPVs and track which CDH Tag they belong to
      const matchResults = {};
      usecases.forEach((uc) => {
        const usecaseName = uc.template_name;
        const spvList = workingUsecaseSPVs[usecaseName] || [];
        const matchedSpvs = []; // Array of {spvName, cdhTagId}
        
        spvList.forEach((spvItem) => {
          const documentCode = (spvItem && spvItem.document_code) ? String(spvItem.document_code) : '';
          if (!documentCode) return;
          
          // Some document codes can be comma-separated; handle each
          const codesToCheck = documentCode.split(',').map((c) => c.trim()).filter(Boolean);
          
          // Build variants: full code and base name (strip two prefixes)
          const baseNames = codesToCheck.map(getBaseNameFromDocumentCode);
          
          // Check match against each CDH Tag ID's equipment tags
          for (const [cdhTagId, equipmentTagTexts] of Object.entries(cdhTagToEquipmentTags)) {
            const hasMatch = codesToCheck.some((full) =>
              equipmentTagTexts.some((tag) => tag.includes(full))
            ) || baseNames.some((base) =>
              equipmentTagTexts.some((tag) => tag.includes(base))
            ) || baseNames.some((base) => {
              const parts = base.split(',').map((p) => p.trim()).filter(Boolean);
              if (parts.length <= 1) return false;
              return parts.every((part) => equipmentTagTexts.some((tag) => tag.includes(part)));
            });
            
            if (hasMatch) {
              // Store the mapped_value (SPV name) with its CDH Tag ID
              let spvName = spvItem.mapped_value || documentCode;
              
              // Strip prefixes from SPV name (Xcols-, FILES-CSV-, etc.)
              if (spvName && typeof spvName === 'string') {
                // Remove first prefix (Xcols-, FILES-, RDBMS-, CLOUD-, OPC-, etc.)
                if (spvName.includes('-')) {
                  spvName = spvName.substring(spvName.indexOf('-') + 1);
                }
                // Remove second prefix (CSV-, XML-, JSON-, etc.) if exists
                if (spvName.includes('-')) {
                  spvName = spvName.substring(spvName.indexOf('-') + 1);
                }
                spvName = spvName.trim();
              }
              
              matchedSpvs.push({ spvName, cdhTagId });
            }
          }
        });
        
        matchResults[usecaseName] = {
          hasMatch: matchedSpvs.length > 0,
          matchedSPVs: matchedSpvs, // Now contains objects with spvName and cdhTagId
        };
      });
      
      // Step 4: Update state with match results
      setSpvMatchResults(matchResults);
      console.log("✅ SPV matching completed:", matchResults);
      
    } catch (error) {
      console.error("❌ Error in handleCdhTagIdChange:", error);
      setSpvMatchResults({});
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (e) => {
      const { name, value, type, files } = e.target;
      setFormValues((prevValues) => ({
          ...prevValues,
          [name]: type === "file" ? files[0] : value,
      }));
  };

  const handleSelectChange = (templateId, masterId, value, text) => {
      setSelectedValues((prevValues) => ({
          ...prevValues,
          [templateId]: {
              ...prevValues[templateId],
              [masterId]: { value, text },
          },
      }));
  };

  const handleAttributeChange = (templateId, attributeId, value) => {
      setSelectedValues((prevValues) => ({
          ...prevValues,
          [templateId]: {
              ...prevValues[templateId],
              [attributeId]: { value },
          },
      }));
  };

  const validateRow = (templateId, assetTemplate) => {
      const selected = selectedValues[templateId] || {};
      let isValid = true;
      const newErrors = {};

      // Check all templateMasters fields
      if (templateMasters[templateId]) {
          templateMasters[templateId].forEach((templateMaster) => {
              if (
                  !selected[templateMaster.master_id] ||
                  !selected[templateMaster.master_id].value
              ) {
                  isValid = false;
                  newErrors[
                      templateMaster.master_id
                  ] = `${templateMaster.master_name} is required`;
              }
          });
      }

      // Check all attribute fields
      assetTemplate.attributes.forEach((attribute) => {
          if (!selected[attribute._id] || !selected[attribute._id].value) {
              isValid = false;
              newErrors[attribute._id] = `${attribute.display_name} is required`;
          }
      });

      if (!isValid) {
          setErrors((prevErrors) => ({
              ...prevErrors,
              [templateId]: {
                  ...prevErrors[templateId],
                  ...newErrors,
                  general: "",
              },
          }));
      } else {
          setErrors((prevErrors) => ({
              ...prevErrors,
              [templateId]: {},
          }));
      }

      return isValid;
  };

  const handleAddClick = (templateId, assetTemplate) => {
      const currentRows = rows[templateId] || [];

      const firstTemplateMasterId = templateMasters[templateId]?.[0]?.master_id;
      const selectedFirstDropdownValue = selectedValues[templateId]?.[firstTemplateMasterId]?.value;

      const duplicateFound = currentRows.some(
          (row) => row?.[firstTemplateMasterId]?.value === selectedFirstDropdownValue
      );

      if (duplicateFound) {
          setErrors((prevErrors) => ({
              ...prevErrors,
              [templateId]: {
                  ...(prevErrors[templateId] || {}),
                  [firstTemplateMasterId]: "This value is already taken.",
              },
          }));
          return;
      }

      if (currentRows.length < parseInt(assetTemplate.rowlimit)) {
          if (validateRow(templateId, assetTemplate)) {
              setRows((prevRows) => ({
                  ...prevRows,
                  [templateId]: [...currentRows, selectedValues[templateId]],
              }));

              setSelectedValues((prevValues) => ({
                  ...prevValues,
                  [templateId]: {},
              }));

              resetFormFields(templateId);

              // clear error after successful add
              setErrors((prevErrors) => ({
                  ...prevErrors,
                  [templateId]: {
                      ...(prevErrors[templateId] || {}),
                      [firstTemplateMasterId]: undefined,
                  },
              }));
          }
      } else {
          toast.error(`Row limit of ${assetTemplate.rowlimit} reached`);
      }
  };

  const resetFormFields = (templateId) => {
      const inputs = document.querySelectorAll(`.row-${templateId} input`);
      const selects = document.querySelectorAll(`.row-${templateId} select`);
      inputs.forEach((input) => (input.value = ""));
      selects.forEach((select) => (select.value = ""));
  };

  const handleDeleteClick = (e, templateId, rowIndex) => {
      e.preventDefault();
      setRows((prevRows) => ({
          ...prevRows,
          [templateId]: prevRows[templateId].filter(
              (_, index) => index !== rowIndex
          ),
      }));
  };
  const handleEditInputChange = (id, selectedOption, isDropdown = false) => {
      setEditRowValues((prevValues) => {
          const updatedValues = {
              ...prevValues,
              [id]: {
                  value: isDropdown ? selectedOption?.value || "" : selectedOption,
                  // Only include the label if it's a dropdown; otherwise, omit it
                  ...(isDropdown && { label: selectedOption?.label || "" }),
              },
          };

          return updatedValues;
      });
  };

  const handleEditClick = (templateId, rowIndex, assetTemplate) => {
      const row = rows[templateId][rowIndex];
      setEditRowTemplateId(templateId);
      setEditRowIndex(rowIndex);
      setEditRowValues(() => {
          const initialValues = {};

          // Process templateMasters for dropdowns
          templateMasters[templateId].forEach((templateMaster) => {
              if (row[templateMaster.master_id]) {
                  initialValues[templateMaster.master_id] = {
                      value: row[templateMaster.master_id].value,
                      label: row[templateMaster.master_id].text || "", // Ensure text is used if available
                  };
              }
          });

          // Process attributes for text inputs
          assetTemplate.attributes.forEach((attribute) => {
              if (row[attribute._id]) {
                  initialValues[attribute._id] = {
                      value: row[attribute._id].value,
                      // label: row[attribute._id].text || row[attribute._id].label || "", // Use text or label if available
                  };
              }
          });

          return initialValues;
      });
  };
  const handleSaveClick = (templateId, e) => {
      e.preventDefault();

      const firstTemplateMasterId = templateMasters[templateId]?.[0]?.master_id;
      const editedFirstDropdownValue = editRowValues[firstTemplateMasterId]?.value;

      // check if that value exists in other rows
      const duplicateFound = rows[templateId].some((row, idx) => {
          return (
              idx !== editRowIndex &&
              row?.[firstTemplateMasterId]?.value === editedFirstDropdownValue
          );
      });

      if (duplicateFound) {
          setErrors((prevErrors) => ({
              ...prevErrors,
              [templateId]: {
                  ...(prevErrors[templateId] || {}),
                  [editRowIndex]: {
                      ...(prevErrors[templateId]?.[editRowIndex] || {}),
                      [firstTemplateMasterId]: "This value is already taken.",
                  },
              },
          }));
          return;
      }

      const updatedRows = rows[templateId].map((row, index) => {
          if (index === editRowIndex) {
              const updatedRow = { ...row };
              for (const key in editRowValues) {
                  updatedRow[key] = {
                      value: editRowValues[key].value,
                      text: editRowValues[key].label,
                  };
              }
              return updatedRow;
          }
          return row;
      });

      setRows((prevRows) => ({
          ...prevRows,
          [templateId]: updatedRows,
      }));

      // clear error after save
      setErrors((prevErrors) => ({
          ...prevErrors,
          [templateId]: {
              ...(prevErrors[templateId] || {}),
              [editRowIndex]: {},
          },
      }));

      // Reset after saving
      setEditRowTemplateId(null);
      setEditRowIndex(null);
      setEditRowValues({});
  };





  const renderFormField = (attribute) => {
      return (
          <div
              key={attribute._id}
              className="col d-flex flex-column addEuipment-form-col"
          >
              <label htmlFor={attribute.field_name} className="addEuipment-form-text">
                  {attribute.display_name}
                  <span style={{ color: "#dc3545" }}>{attribute.required && " *"}</span>
              </label>
              {errors[attribute.field_name] && (
                  <div
                      className="error mt-2"
                      style={{ color: "#dc3545", marginLeft: "8px" }}
                  >
                      {errors[attribute.field_name]}
                  </div>
              )}
          </div>
      );
  };



  const groupedItems = [];
  for (let i = 0; i < assetAttributes.length; i += 2) {
      groupedItems.push(assetAttributes.slice(i, i + 2));
  }
  const handleOpenuploadModal = (isOpen, templateId, templatename) => {
      setShowUploadModal(isOpen);
      setSelectedTemplateId(templateId);
      setSelectedTemplateName(templatename)// Store the template ID in state
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const handleCloseUploadModal = () => {
      setErrorMessages("");
      setErrorrowMessages("");
      setShowUploadModal(false);
      setSelectedFile(null); // Clear the selected file
  };







  const fetchMasterValues = async (masterId) => {
      try {
          const response = await fetch(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/get-masters`,
              {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ masterId }),
              }
          );
          if (!response.ok) throw new Error("Failed to fetch master values");
          const data = await response.json();
          return data || []; // return the array directly, no data.data
      } catch (error) {
          return [];
      }
  };

  // Load master options only when assetTemplates are available (for modal functionality)
  useEffect(() => {
      const loadAllMasterOptions = async () => {
          // Only load if assetTemplates exist and we have data
          if (!assetTemplates || assetTemplates.length === 0) return;
          
          const newMap = {};

          for (const template of assetTemplates) {
              for (const attr of template.attributes) {
                  if (attr.master_id && !newMap[attr.master_id]) {
                      const options = await fetchMasterValues(attr.master_id);
                      newMap[attr.master_id] = options;
                  }
              }
          }

          setMasterOptionsMap(newMap);
      };

      loadAllMasterOptions();
  }, [assetTemplates]);
  // ------------------------------------------


  const fetchAllEquipments = async () => {
    setLoading(true);
    try {
      const equipmentResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/getall`,
        { method: "POST", body: JSON.stringify({}) }
      );
      return equipmentResponse.data || [];
    } catch (error) {
      return [];
    } finally {
      setLoading(false);
    }
  };

  // Simple approach: Get CDH Tag IDs from templateattributes and match with equipment templates
  const fetchAllCdhTagIds = async () => {
    try {
      console.log("🔍 STEP 1: Fetching template attributes with field_name='var_cdh_tag'");
      
      // Step 1: Get template attributes where field_name is "var_cdh_tag"
      const templateAttributesResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-attribute/getall`,
        { method: "POST", body: JSON.stringify({}) }
      );
      
      const allTemplateAttributes = Array.isArray(templateAttributesResponse) 
        ? templateAttributesResponse 
        : (templateAttributesResponse?.data || []);
      
      console.log("📊 Total template attributes:", allTemplateAttributes.length);
      
      // Filter for CDH Tag attributes
      const cdhTagAttributes = allTemplateAttributes.filter(attr => 
        attr.field_name === "var_cdh_tag"
      );
      
      console.log("📊 CDH Tag attributes found:", cdhTagAttributes.length);
      
      if (cdhTagAttributes.length === 0) {
        console.log("❌ No CDH Tag attributes found");
        return [];
      }
      
      // Get template IDs from CDH Tag attributes
      const templateIds = cdhTagAttributes.map(attr => attr.template_id).filter(Boolean);
      console.log("📊 Template IDs to match:", templateIds);
      
      // Step 2: Get all equipments
      console.log("🔍 STEP 2: Fetching all equipments");
      const equipmentResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/getall`,
        { method: "POST", body: JSON.stringify({}) }
      );
      
      const equipments = equipmentResponse?.data || [];
      console.log("📊 Total equipments:", equipments.length);
      
      // Step 3: Extract CDH Tag IDs from equipment templates
      console.log("🔍 STEP 3: Extracting CDH Tag IDs from equipment templates");
      const cdhTagIds = new Set();
      
      equipments.forEach((equipment, equipmentIndex) => {
        if (equipment.templates && typeof equipment.templates === "object") {
          // Check each template ID that we found in template attributes
          templateIds.forEach(templateId => {
            const templateIdStr = templateId.toString();
            
            // Check if this equipment has this template_id in its templates object
            if (equipment.templates[templateIdStr]) {
              const templateArray = equipment.templates[templateIdStr];
              
              if (Array.isArray(templateArray)) {
                templateArray.forEach((templateItem, itemIndex) => {
                  if (templateItem && typeof templateItem === 'object') {
                    // Look for CDH Tag values in the template item
                    Object.entries(templateItem).forEach(([key, value]) => {
                      console.log(`Checking key: ${key}, value:`, value);
                      
                      if (typeof value === 'string' && value.trim()) {
                        // Check if it looks like a CDH Tag ID (V- pattern)
                        if (value.includes('V-') && value.includes('-')) {
                          cdhTagIds.add(value.trim());
                          console.log(`✅ Found CDH Tag ID (string): ${value.trim()}`);
                        }
                      } else if (value && typeof value === 'object') {
                        // If value is an object, check its properties
                        console.log(`Checking object value for key ${key}:`, value);
                        
                        // Check if the object has a 'value' property that contains CDH Tag ID
                        if (value.value && typeof value.value === 'string' && value.value.includes('V-') && value.value.includes('-')) {
                          cdhTagIds.add(value.value.trim());
                          console.log(`✅ Found CDH Tag ID (object.value): ${value.value.trim()}`);
                        }
                        
                        // Also check other string properties
                        Object.entries(value).forEach(([subKey, subValue]) => {
                          if (typeof subValue === 'string' && subValue.trim()) {
                            if (subValue.includes('V-') && subValue.includes('-')) {
                              cdhTagIds.add(subValue.trim());
                              console.log(`✅ Found CDH Tag ID (object.${subKey}): ${subValue.trim()}`);
                            }
                          }
                        });
                      }
                    });
                  }
                });
              }
            }
          });
        }
      });
      
      const tagIds = Array.from(cdhTagIds).sort();
      console.log("📋 Total unique CDH Tag IDs found:", tagIds.length);
      console.log("📋 All CDH Tag IDs:", tagIds);
      
      return tagIds;
    } catch (error) {
      console.error("❌ Error fetching CDH Tag IDs:", error);
      return [];
    }
  };

  // Check SPV match for a specific usecase
  const checkUsecaseSPVMatch = async (usecaseName) => {
    try {
      // Find the usecase by name
      const usecase = usecases.find(uc => uc.template_name === usecaseName);
      if (!usecase) return { hasMatch: false, matchedSPVs: [] };

      const templateId = usecase._id;
      
      // Get SPV master and fetch all SPVs
      const spvMasterResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/get-svp`,
        { method: "GET" }
      );
      const masterId = spvMasterResponse._id;

      const spvCollectionResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/collections/${masterId}/data`,
        { method: "GET" }
      );
      const allSPVs = (spvCollectionResponse.data || []).map(spv => spv.value).filter(Boolean);

      // Check if the selected CDH Tag ID matches any SPV
      const matchedSPVs = allSPVs.filter(spv => 
        spv.includes(selectedCdhTagId) || selectedCdhTagId.includes(spv)
      );

      return {
        hasMatch: matchedSPVs.length > 0,
        matchedSPVs: matchedSPVs
      };
    } catch (error) {
      console.error("Error checking usecase SPV match:", error);
      return { hasMatch: false, matchedSPVs: [] };
    }
  };

  // Removed automatic loading of CDH Tag IDs on mount for better performance
  // CDH Tag IDs will be validated when user submits
  // useEffect(() => {
  //   const loadCdhTagIds = async () => {
  //     console.log("🚀 Loading CDH Tag IDs...");
  //     try {
  //       const tagIds = await fetchAllCdhTagIds();
  //       console.log("📋 Setting CDH Tag IDs:", tagIds);
  //       console.log("📋 CDH Tag IDs length:", tagIds.length);
  //       setCdhTagIds(tagIds);
  //     } catch (error) {
  //       console.error("❌ Error loading CDH Tag IDs:", error);
  //       setCdhTagIds([]);
  //     }
  //   };
  //   loadCdhTagIds();
  // }, []);

const fetchUsecaseData = async (selectedUsecase) => {
  if (!selectedUsecase || !selectedUsecase._id) return;
  setLoading(true);

  try {
    // First load equipment data when usecase is selected
      const equipments = await fetchAllEquipments();
    
    let processedEquipments = [];
    
      if (equipments && equipments.length > 0) {
      processedEquipments = equipments.map((eqpt) => {
          const equipmentTagValues = [];
          if (eqpt.templates && typeof eqpt.templates === "object") {
            Object.values(eqpt.templates).forEach((templateArray) => {
              if (Array.isArray(templateArray)) {
                templateArray.forEach((attributeObj) => {
                  if (attributeObj && typeof attributeObj === "object") {
                    Object.values(attributeObj).forEach((tag) => {
                      if (tag && tag.text) {
                        equipmentTagValues.push(tag.text);
                      }
                    });
                  }
                });
              }
            });
          }
          
          const numberOfTags = equipmentTagValues.length;
          
          return {
            _id: eqpt._id,
            equipment_code:
              eqpt.equipment_code || eqpt.equipment_name || eqpt._id,
            equipment_name: eqpt.equipment_name || "Unknown",
            capacity: eqpt.capacity || "N/A",
            numberOfTags: numberOfTags,
            totalConfigured: 0,
            matchCount: 0, 
            percentMatch: "0.00",
            matchedSpvs: [],
            fullData: eqpt,
          };
        });
      }

    const templateId = selectedUsecase._id;
    
    const templateMastersResponse = await fetchWrapper(
      `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-masters/${templateId}`,
      { method: "POST", body: JSON.stringify({}) }
    );
    const templateMasters = templateMastersResponse.data || [];
    
    if (templateMasters.length === 0) {
      alert("Kindly enter template masters for the selected template.");
      return;
    }
    
    // Filter ONLY for exact "Standard Process Variables" - no linked items
      const spvMasters = templateMasters.filter(
      (master) => master.master_name === "Standard Process Variables" && master.leaf_node === true
    );
    
    if (spvMasters.length === 0) {
        alert(
          "No 'Standard Process Variables' found for this template. Kindly configure template masters."
        );
      return;
    }

    // Split comma-separated document_codes into individual SPV codes for matching
    const useCaseSpvCodes = [];
    spvMasters.forEach((master) => {
      if (master.document_code) {
        // Split by comma and trim whitespace
        const codes = master.document_code.split(',').map(code => code.trim());
        useCaseSpvCodes.push(...codes);
      }
    });
    
    // Group by template_id and then extract unique base names within each group
    const groupedByTemplateId = {};
    spvMasters.forEach(master => {
      const templateId = master.template_id;
      if (!groupedByTemplateId[templateId]) {
        groupedByTemplateId[templateId] = [];
      }
      groupedByTemplateId[templateId].push(master);
    });
    
    // Count unique base names within each template_id group
    let totalUniqueBaseNames = 0;
    const allUniqueBaseNames = new Set();
    
    Object.keys(groupedByTemplateId).forEach(templateId => {
      const mastersInTemplate = groupedByTemplateId[templateId];
      
      // Extract base names for this template
      const baseNamesInTemplate = mastersInTemplate.map(master => {
        const documentCode = master.document_code;
        
        // Remove ALL prefixes (FILES-CSV-, RDBMS-CSV-, etc.) to get the true base name
        let baseName = documentCode;
        
        // Remove first prefix (FILES-, RDBMS-, CLOUD-, OPC-)
        if (baseName.includes('-')) {
          baseName = baseName.substring(baseName.indexOf('-') + 1);
        }
        
        // Remove second prefix (CSV-, XML-, JSON-, etc.) if exists
        if (baseName.includes('-')) {
          baseName = baseName.substring(baseName.indexOf('-') + 1);
        }
        
        return baseName;
      });
      
      // Get unique base names for this template
      const uniqueBaseNamesInTemplate = [...new Set(baseNamesInTemplate)];
      totalUniqueBaseNames += uniqueBaseNamesInTemplate.length;
      
      // Also track all unique base names globally
      uniqueBaseNamesInTemplate.forEach(baseName => allUniqueBaseNames.add(baseName));
    });
    
    const useCaseSpvCount = totalUniqueBaseNames;
    
    // Keep original document codes for matching
    const uniqueDocumentCodes = [...new Set(spvMasters.map(master => master.document_code))];

      const spvMasterMapping = {};
      spvMasters.forEach((master) => {
        spvMasterMapping[master.document_code] = master.mapped_value || "N/A";
      });
      setSpvMappings(spvMasterMapping);

    const updatedEquipments = processedEquipments.map((equipment, index) => {
      // Extract equipment tags
      const equipmentTags = [];
        if (
          equipment.fullData &&
          equipment.fullData.templates &&
          typeof equipment.fullData.templates === "object"
        ) {
          Object.values(equipment.fullData.templates).forEach((templateArray) => {
          if (Array.isArray(templateArray)) {
              templateArray.forEach((attributeObj) => {
                if (attributeObj && typeof attributeObj === "object") {
                  Object.values(attributeObj).forEach((tag) => {
                  if (tag && tag.text) {
                    equipmentTags.push(tag.text);
                  }
                });
              }
            });
          }
        });
      }
      
      // Use the same logic as usecase count: group by template_id and check unique base names
      const matchedUniqueBaseNames = new Set(); // Track unique base names that match (across all templates)
      let totalMatchedBaseNames = 0; // Count unique base names per template
      
      Object.keys(groupedByTemplateId).forEach(templateId => {
        const mastersInTemplate = groupedByTemplateId[templateId];
        const templateMatchedBaseNames = new Set(); // Track unique base names for this template
        
        mastersInTemplate.forEach(master => {
          const documentCode = master.document_code;
          
          // Apply same double prefix removal as in usecase count
          let baseName = documentCode;
          
          // Remove first prefix (FILES-, RDBMS-, CLOUD-, OPC-)
          if (baseName.includes('-')) {
            baseName = baseName.substring(baseName.indexOf('-') + 1);
          }
          
          // Remove second prefix (CSV-, XML-, JSON-, etc.) if exists
          if (baseName.includes('-')) {
            baseName = baseName.substring(baseName.indexOf('-') + 1);
          }
          
          // Method 1: Check if any equipment tag contains the complete document_code (with prefixes)
          const tagContainsComplete = equipmentTags.some(tag => tag.includes(documentCode));
          
          // Method 2: Check if any equipment tag contains the base name (without prefixes)
          const tagContainsBaseName = equipmentTags.some(tag => tag.includes(baseName));
          
          // Method 3: Split base name and check if all parts are present in equipment tags
          const baseParts = baseName.split(',').map(part => part.trim());
          const allBasePartsPresent = baseParts.every(part => 
            equipmentTags.some(tag => tag.includes(part))
          );
          
          // Consider it a match if any condition is true
          if (tagContainsComplete || tagContainsBaseName || allBasePartsPresent) {
            templateMatchedBaseNames.add(baseName); // Track for this template
            matchedUniqueBaseNames.add(baseName); // Track globally
          }
        });
        
        // Add unique base names count from this template
        totalMatchedBaseNames += templateMatchedBaseNames.size;
      });
      
      // Use same counting logic as usecase count
      const matchCount = totalMatchedBaseNames;
      
        const percentMatch =
          useCaseSpvCount > 0
        ? ((matchCount / useCaseSpvCount) * 100).toFixed(2) 
        : "0.00";
      
      return {
        ...equipment,
        // Keep original numberOfTags (ALL tags regardless of usecase)
        totalConfigured: useCaseSpvCount,
        matchCount: matchCount,
          percentMatch: percentMatch,
          matchedSpvs: [...matchedUniqueBaseNames], // Use unique base names for consistency
      };
    });

    setGroupedData(updatedEquipments);
      setPage(1);
    setCurrentPage(1);
  } catch (error) {
      alert("Error fetching template masters. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleview = async (equipmentId) => {
    const equipment = groupedData.find((eq) => eq._id === equipmentId);
    if (equipment) {
      setSelectedEquipment(equipment);
      setShowModal(true);
      // Fetch asset class data and equipment details for the modal
      await getAssetClass();
      await getEquipment(equipmentId);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEquipment(null);
  };

  const handleShowSpvModal = (usecaseName) => {
    const usecaseSPVList = usecaseSPVs[usecaseName] || [];
    const matchResult = spvMatchResults[usecaseName] || { hasMatch: false, matchedSPVs: [] };
    
    setSelectedUsecaseName(usecaseName);
    setSelectedUsecaseSpvs({
      usecaseSPVs: usecaseSPVList,
      matchedSPVs: matchResult.matchedSPVs || [],
      hasMatch: matchResult.hasMatch
    });
    setShowSpvModal(true);
  };

  const handleCloseSpvModal = () => {
    setShowSpvModal(false);
    setSelectedUsecaseSpvs([]);
    setSelectedUsecaseName('');
  };

  // Temporarily show all equipment for debugging
  const filteredData = groupedData; // .filter((item) => item.matchCount > 0);

  // Get all usecases for pagination
  const allUsecases = usecases.map(usecase => usecase.template_name).filter(Boolean);
  
  const indexOfLastItem = page * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const currentItems = allUsecases.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    setTotalItems(allUsecases.length);
    setTotalPages(Math.ceil(allUsecases.length / pageSize));
  }, [usecases, pageSize]);


  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
      setPage(newPage);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
    setCurrentPage(1);
  };




  const renderTableData = () => {
    // Show paginated usecases
    if (currentItems.length > 0) {
      return currentItems.map((usecase, index) => {
        const usecaseSPVList = usecaseSPVs[usecase] || [];
        const spvCount = usecaseSPVList.length;
        const matchResult = spvMatchResults[usecase] || { hasMatch: false, matchedSPVs: [] };
        
        return (
          <tr key={`usecase-${index}`}>
            <td>
              <div className="d-flex align-items-center p-2">
                {usecase}
              </div>
            </td>
            <td className="">
              {selectedCdhTagId ? (
                matchResult.hasMatch ? (
                  <IoCheckmark 
                    style={{ 
                      fontSize: '1.5rem', 
                      color: '#28a745',
                      cursor: 'pointer'
                    }} 
                    title="Match Found"
                  />
                ) : (
                  <IoClose 
                    style={{ 
                      fontSize: '1.5rem', 
                      color: '#dc3545',
                      cursor: 'pointer'
                    }} 
                    title="No Match"
                  />
                )
              ) : (
                <span className="text-muted">-</span>
              )}
            </td>
            
            <td className="">
              <button
                type="button"
                className="p-0"
                onClick={() => handleShowSpvModal(usecase)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  padding: '0',
                  cursor: 'pointer'
                }}
                title="View SPVs"
              >
                <IoEye style={{ fontSize: '1rem' }} />
              </button>
            </td>
          </tr>
        );
      });
    }
    
    // Show message when no usecases are available
    return (
      <tr>
        <td colSpan="3" className="text-center py-5">
          <div className="d-flex flex-column align-items-center">
            <i className="fas fa-tags fa-3x text-muted mb-3"></i>
            <h6 className="text-muted mb-2">No usecases available</h6>
            <p className="text-muted mb-0">
              No usecases found in the system.
            </p>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      {loading && <Loader />}
      <div className="container pt-3">
        <div className="pt-3 pb-0 d-flex justify-content-between">
        <div>
          <h5>Asset Tag Mapping</h5>
          <nav className="breadcrumb-nav" aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="#" style={{ textDecoration: "none" }}>
                  Review
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Asset Tag Mapping
              </li>
            </ol>
          </nav>
        </div>

        <div className="d-flex align-items-center  gap-3">
          <div className="form-group">
            <input
              ref={cdhTagInputRef}
              type="text"
              className="form-control"
              placeholder="Enter CDH Tag IDs (comma-separated)"
              value={selectedCdhTagId || ''}
              onChange={(e) => {
                setSelectedCdhTagId(e.target.value);
              }}
              style={{ 
                padding: "10px", 
                width: "500px", 
                borderRadius: "8px",
                border: "1px solid #ced4da",
                fontSize: "14px"
              }}
            />
          </div>
          <div className="d-flex align-items-end">
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                if (selectedCdhTagId && selectedCdhTagId.trim()) {
                  handleCdhTagIdChange(selectedCdhTagId.trim());
                } else {
                  alert("Please enter at least one CDH Tag ID");
                }
              }}
              disabled={loading}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "500"
              }}
            >
              {loading ? 'Processing...' : 'Submit'}
            </button>
          </div>
        </div>
      </div>

      <div className="table-responsive mt-3">
        <table className="table align-middle table-text">
          <thead className="table-head align-middle">
            <tr>
              <th>Usecases</th>
              <th>Present</th>
             
              <th>View</th>
            </tr>
          </thead>
          <tbody>{renderTableData()}</tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        pageSize={pageSize}
        onPageSizeChange={handlePageSizeChange}
        totalItems={totalItems}
        startIndex={indexOfFirstItem + 1}
        endIndex={Math.min(indexOfLastItem, totalItems)}
      />

      {/* Variables Modal */}
      {showModal && selectedEquipment && (
        <div
          id="overlay"
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{
            zIndex: 30,
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="addunit-card" style={{ width: "95%", maxWidth: "100%", height: "95vh" }}>
            <div className="addunit-header">
              <h4>CDH Tag ID Details - {selectedCdhTagId}</h4>
              <button
                style={{ border: "none", backgroundColor: "inherit" }}
                type="button"
                className="close"
                onClick={handleCloseModal}
              >
                <img src={closeIcon} width="28px" height="28px" alt="Close" />
              </button>
            </div>
            <div className="addunit-form" style={{ maxHeight: "calc(95vh - 120px)", overflowY: "auto" }}>
                <div className="container">
                  <div className="row mb-4">
                    <div className="d-flex justify-content-between align-items-center col-sm-12 mb-2">
                      <h5 className="mb-1">CDH Tag ID Match Details</h5>
                    </div>
                    
                    {/* Show SPV matches for each usecase */}
                    <div className="col-sm-12 mb-3">
                      <h6>Usecase SPV Matches:</h6>
                      <div className="table-responsive">
                        <table className="table table-sm">
                          <thead>
                            <tr>
                              <th>Usecase</th>
                              <th>Match Status</th>
                              <th>Matched SPVs</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(usecaseMatchResults).map(([usecaseName, result], index) => (
                              <tr key={index}>
                                <td>{usecaseName}</td>
                                <td>
                                  <span className={`badge ${result.hasMatch ? 'bg-success' : 'bg-secondary'}`}>
                                    {result.hasMatch ? 'Match' : 'No Match'}
                                  </span>
                                </td>
                                <td>
                                  {result.matchedSPVs.length > 0 ? (
                                    <div>
                                      {result.matchedSPVs.map((spv, idx) => (
                                        <span key={idx} className="badge bg-info me-1 mb-1">
                                          {spv}
                                        </span>
                                      ))}
                                    </div>
                                  ) : (
                                    <span className="text-muted">No matches</span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="table-responsive">
                       <table className="table align-middle table-text">
                           <thead className="table-head align-middle">
                               <tr>
                                   <th className="text-center">#</th>
                            <th className="text-uppercase">CDH Tag Name</th>
                            <th className="text-uppercase">Equipment Tags</th>
                            <th className="text-uppercase">Minimum Value</th>
                            <th className="text-uppercase">Maximum Value</th>
                            <th className="text-uppercase">Lower Control Limit</th>
                            <th className="text-uppercase">Upper Control Limit</th>
                            <th className="text-uppercase">FlatLine Length (min)</th>
                            <th className="text-uppercase">PI Tag ID</th>
                                   <th className="text-uppercase">PI WEB ID</th>
                                   <th className="text-uppercase">KM Tag ID</th>
                                   <th className="text-uppercase">KM RI Code</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            if (!selectedCdhTagId) {
                              return (
                                <tr>
                                  <td colSpan="11" className="text-center py-5">
                                    <div className="d-flex flex-column align-items-center">
                                      <i className="fas fa-tags fa-3x text-muted mb-3"></i>
                                      <h6 className="text-muted mb-2">No CDH Tag Name Selected</h6>
                                      <p className="text-muted mb-0">
                                        Please select a CDH Tag Name to view details.
                                      </p>
                                               </div>
                                           </td>
                                       </tr>
                              );
                            }
                            
                            // Show the selected CDH Tag Name details
                            const equipmentTags = [];
                            let attributeValues = {
                              minimumValue: '',
                              maximumValue: '',
                              lowerControlLimit: '',
                              upperControlLimit: '',
                              flatlineLength: '',
                              piTagId: '',
                              piWebId: '',
                              kmTagId: '',
                              kmRiCode: ''
                            };
                            
                            // Create attribute mapping based on display names
                            const attributeMapping = {};
                            if (assetTemplates && Array.isArray(assetTemplates)) {
                              assetTemplates.forEach(template => {
                                if (template.attributes && Array.isArray(template.attributes)) {
                                  template.attributes.forEach(attr => {
                                    const displayName = attr.display_name?.toLowerCase() || '';
                                    if (displayName.includes('minimum') && displayName.includes('value')) {
                                      attributeMapping.minimumValue = attr._id;
                                    } else if (displayName.includes('maximum') && displayName.includes('value')) {
                                      attributeMapping.maximumValue = attr._id;
                                    } else if (displayName.includes('lower') && displayName.includes('control')) {
                                      attributeMapping.lowerControlLimit = attr._id;
                                    } else if (displayName.includes('upper') && displayName.includes('control')) {
                                      attributeMapping.upperControlLimit = attr._id;
                                    } else if (displayName.includes('flatline')) {
                                      attributeMapping.flatlineLength = attr._id;
                                    } else if (displayName.includes('pi') && displayName.includes('tag') && !displayName.includes('web')) {
                                      attributeMapping.piTagId = attr._id;
                                    } else if (displayName.includes('pi') && displayName.includes('web')) {
                                      attributeMapping.piWebId = attr._id;
                                    } else if (displayName.includes('km') && displayName.includes('tag')) {
                                      attributeMapping.kmTagId = attr._id;
                                    } else if (displayName.includes('km') && displayName.includes('ri')) {
                                      attributeMapping.kmRiCode = attr._id;
                                    }
                                  });
                                }
                              });
                            }
                            
                            // Search through rows data to find matching CDH Tag ID and extract values
                            if (rows && typeof rows === 'object') {
                              Object.entries(rows).forEach(([templateId, templateRows]) => {
                                if (Array.isArray(templateRows)) {
                                  templateRows.forEach((row) => {
                                    if (row && typeof row === "object") {
                                      // Check if this row contains the selected CDH Tag Name
                                      let hasMatchingTag = false;
                                      
                                      // Search through all fields in the row to find tags
                                      Object.entries(row).forEach(([fieldKey, field]) => {
                                        if (field && (field.text || field.name || field.label || field.display_name)) {
                                          const fieldValue = field.text || field.name || field.label || field.display_name;
                                          if (fieldValue.includes(selectedCdhTagId)) {
                                            hasMatchingTag = true;
                                            if (!equipmentTags.includes(fieldValue)) {
                                              equipmentTags.push(fieldValue);
                                            }
                                          }
                                        }
                                      });
                                      
                                      // If this row has a matching tag, extract attribute values using the mapping
                                      if (hasMatchingTag) {
                                        // Use attribute mapping to get correct values
                                        if (attributeMapping.minimumValue && row[attributeMapping.minimumValue]) {
                                          attributeValues.minimumValue = row[attributeMapping.minimumValue]?.text || row[attributeMapping.minimumValue]?.value || '';
                                        }
                                        if (attributeMapping.maximumValue && row[attributeMapping.maximumValue]) {
                                          attributeValues.maximumValue = row[attributeMapping.maximumValue]?.text || row[attributeMapping.maximumValue]?.value || '';
                                        }
                                        if (attributeMapping.lowerControlLimit && row[attributeMapping.lowerControlLimit]) {
                                          attributeValues.lowerControlLimit = row[attributeMapping.lowerControlLimit]?.text || row[attributeMapping.lowerControlLimit]?.value || '';
                                        }
                                        if (attributeMapping.upperControlLimit && row[attributeMapping.upperControlLimit]) {
                                          attributeValues.upperControlLimit = row[attributeMapping.upperControlLimit]?.text || row[attributeMapping.upperControlLimit]?.value || '';
                                        }
                                        if (attributeMapping.flatlineLength && row[attributeMapping.flatlineLength]) {
                                          attributeValues.flatlineLength = row[attributeMapping.flatlineLength]?.text || row[attributeMapping.flatlineLength]?.value || '';
                                        }
                                        if (attributeMapping.piTagId && row[attributeMapping.piTagId]) {
                                          attributeValues.piTagId = row[attributeMapping.piTagId]?.text || row[attributeMapping.piTagId]?.value || '';
                                        }
                                        if (attributeMapping.piWebId && row[attributeMapping.piWebId]) {
                                          attributeValues.piWebId = row[attributeMapping.piWebId]?.text || row[attributeMapping.piWebId]?.value || '';
                                        }
                                        if (attributeMapping.kmTagId && row[attributeMapping.kmTagId]) {
                                          attributeValues.kmTagId = row[attributeMapping.kmTagId]?.text || row[attributeMapping.kmTagId]?.value || '';
                                        }
                                        if (attributeMapping.kmRiCode && row[attributeMapping.kmRiCode]) {
                                          attributeValues.kmRiCode = row[attributeMapping.kmRiCode]?.text || row[attributeMapping.kmRiCode]?.value || '';
                                        }
                                      }
                                    }
                                  });
                                }
                              });
                            }
                            
                            return (
                              <tr>
                                <td className="text-center">
                                  <strong className="text-muted">1</strong>
                                </td>
                                <td>
                                  <strong className="text-primary">{selectedCdhTagId}</strong>
                                </td>
                                <td>
                                  <div className="d-flex flex-column" style={{maxWidth: '200px'}}>
                                    {equipmentTags.length > 0 ? (
                                      <>
                                        <span className="fw-semibold text-muted">{equipmentTags[0]}</span>
                                        {equipmentTags.length > 1 && (
                                          <small className="text-muted">
                                            +{equipmentTags.length - 1} more tags
                                          </small>
                                        )}
                                      </>
                                    ) : (
                                      <span className="text-muted">N/A</span>
                                    )}
                                  </div>
                                </td>
                                <td className="text-center">
                                  <span className="fw-semibold text-muted">
                                    {attributeValues.minimumValue || '-'}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="fw-semibold text-muted">
                                    {attributeValues.maximumValue || '-'}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="fw-semibold text-muted">
                                    {attributeValues.lowerControlLimit || '-'}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="fw-semibold text-muted">
                                    {attributeValues.upperControlLimit || '-'}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="fw-semibold text-muted">
                                    {attributeValues.flatlineLength || '-'}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="fw-semibold text-muted">
                                    {attributeValues.piTagId || '-'}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="fw-semibold text-muted">
                                    {attributeValues.piWebId || '-'}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="fw-semibold text-muted">
                                    {attributeValues.kmTagId || '-'}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="fw-semibold text-muted">
                                    {attributeValues.kmRiCode || '-'}
                                  </span>
                                </td>
                              </tr>
                            );
                          })()}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

             
            </div>
        </div>
      )}

      {/* SPV Modal (UI aligned with SvpMapping view modal) */}
      {showSpvModal && (
        <div
          id="overlay"
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{
            zIndex: 30,
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="addunit-card" style={{ width: "95%", maxWidth: "100%", height: "95vh" }}>
            <div className="addunit-header">
              <h4>SPV Details - {selectedUsecaseName}</h4>
              <button
                style={{ border: "none", backgroundColor: "inherit" }}
                type="button"
                className="close"
                onClick={handleCloseSpvModal}
              >
                <img src={closeIcon} width="28px" height="28px" alt="Close" />
              </button>
            </div>

            <div className="addunit-form" style={{ maxHeight: "calc(95vh - 120px)", overflowY: "auto" }}>
              <div className="container">
                <div className="row mb-2">
                  <div className="col-sm-12">
                    <div className="table-responsive">
                      {selectedUsecaseSpvs.hasMatch && selectedUsecaseSpvs.matchedSPVs.length > 0 ? (
                        (() => {
                          // matchedSPVs is now an array of objects {spvName, cdhTagId}
                          // Group by spvName to handle duplicates
                          const spvMap = {};
                          selectedUsecaseSpvs.matchedSPVs.forEach(item => {
                            if (typeof item === 'object' && item.spvName) {
                              if (!spvMap[item.spvName]) {
                                spvMap[item.spvName] = [];
                              }
                              if (!spvMap[item.spvName].includes(item.cdhTagId)) {
                                spvMap[item.spvName].push(item.cdhTagId);
                              }
                            }
                          });
                          
                          // Get unique CDH Tag IDs
                          const allCdhTags = selectedCdhTagId ? selectedCdhTagId.split(',').map(tag => tag.trim()) : [];
                          
                          // Group SPVs by their CDH Tag relationship
                          const groupedSpvs = [];
                          
                          // 1. SPVs belonging to individual tags only
                          allCdhTags.forEach(cdhTag => {
                            const spvsForThisTag = Object.entries(spvMap)
                              .filter(([spvName, tags]) => tags.length === 1 && tags[0] === cdhTag)
                              .map(([spvName, tags]) => ({ spvName, cdhTags: tags }))
                              .sort((a, b) => a.spvName.localeCompare(b.spvName));
                            
                            if (spvsForThisTag.length > 0) {
                              groupedSpvs.push({
                                title: cdhTag,
                                spvs: spvsForThisTag
                              });
                            }
                          });
                          
                          // 2. SPVs belonging to multiple tags
                          const multiTagSpvs = Object.entries(spvMap)
                            .filter(([spvName, tags]) => tags.length > 1)
                            .map(([spvName, tags]) => ({ spvName, cdhTags: tags }))
                            .sort((a, b) => a.spvName.localeCompare(b.spvName));
                          
                          if (multiTagSpvs.length > 0) {
                            groupedSpvs.push({
                              title: 'Multiple CDH Tags',
                              spvs: multiTagSpvs
                            });
                          }
                          
                          // Flatten all SPVs from all groups into a single array
                          const allSpvs = [];
                          groupedSpvs.forEach(group => {
                            group.spvs.forEach(spv => {
                              allSpvs.push(spv);
                            });
                          });
                          
                          return (
                            <table className="table table-bordered table-hover align-middle">
                              <thead className="table-light">
                                <tr>
                                  <th style={{ width: '60px', textAlign: 'center' }}>#</th>
                                  <th>SPV Name</th>
                                  <th style={{ width: '300px' }}>CDH Tag ID</th>
                                </tr>
                              </thead>
                              <tbody>
                                {allSpvs.map((item, index) => (
                                  <tr key={index}>
                                    <td style={{ textAlign: 'center', fontWeight: 'bold', color: '#6c757d' }}>
                                      {index + 1}
                                    </td>
                                    <td style={{ fontSize: '0.9rem' }}>{item.spvName}</td>
                                    <td>
                                      <div className="d-flex flex-wrap gap-1">
                                        {item.cdhTags.map((tag, tagIndex) => (
                                          <span 
                                            key={tagIndex}
                                            style={{ 
                                              fontSize: '0.85rem',
                                              color: '#212529'
                                            }}
                                          >
                                            {tag}
                                            {tagIndex < item.cdhTags.length - 1 ? ',' : ''}
                                          </span>
                                        ))}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          );
                        })()
                      ) : (
                        <div className="text-center p-5">
                          <p className="text-muted">
                            {selectedCdhTagId ? 'No matches found' : 'Select a CDH Tag ID to see matches'}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </>
  );
};

export default AssetTagMapping;
